export default __webpack_public_path__ + "58a8d7ebc386843b62c53592b03d09b1.woff2";